import React from 'react';

const ArrowDownIconNew = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...rest}>
      <mask id="mask0_551_5048" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24" style={{ maskType: 'alpha' }}>
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_551_5048)">
        <path d="M12 15.6769C11.8795 15.6769 11.7673 15.6577 11.6635 15.6192C11.5597 15.5807 11.4609 15.5147 11.3674 15.4211L6.87313 10.9269C6.73466 10.7884 6.66383 10.6144 6.66063 10.4048C6.65741 10.1952 6.72824 10.018 6.87313 9.87309C7.01799 9.7282 7.19363 9.65576 7.40003 9.65576C7.60643 9.65576 7.78206 9.7282 7.92693 9.87309L12 13.9462L16.0731 9.87309C16.2116 9.73462 16.3856 9.66379 16.5952 9.66059C16.8048 9.65737 16.9821 9.7282 17.1269 9.87309C17.2718 10.018 17.3443 10.1936 17.3443 10.4C17.3443 10.6064 17.2718 10.782 17.1269 10.9269L12.6327 15.4211C12.5391 15.5147 12.4404 15.5807 12.3366 15.6192C12.2327 15.6577 12.1205 15.6769 12 15.6769Z" fill="#6D7885" />
      </g>
    </svg>
  );
};

export default ArrowDownIconNew;